import { includes } from 'lodash'
import { TradeActionEnum } from '../Types'

export const isBuy = (action: TradeActionEnum) =>
  includes(
    [TradeActionEnum.Buy, TradeActionEnum.BuyToClose, TradeActionEnum.BuyToCover, TradeActionEnum.BuyToOpen],
    action
  )
